import { render, staticRenderFns } from "./editBasicInfo.vue?vue&type=template&id=40e487a8"
import script from "./editBasicInfo.vue?vue&type=script&lang=js"
export * from "./editBasicInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports